import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { DateSeparator } from "./DateSeparator";

export interface AgendaGroup {
  readonly date: Date;
  readonly items: readonly AgendaGroupItem[];
}

export interface AgendaGroupItem {
  readonly id: string;
  readonly content: ReactNode;
}

export interface AgendaListProps {
  readonly groups: readonly AgendaGroup[];
  readonly selectedId?: string;
  readonly onItemClick?: (id: string) => void;
  readonly className?: string;
}

export function AgendaList({
  groups,
  selectedId: _selectedId,
  onItemClick,
  className,
}: AgendaListProps): JSX.Element {
  if (groups.length === 0) {
    return (
      <div className={cn("py-10 px-4 text-center text-content-tertiary text-sm", className)}>
        No meetings in this period
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col", className)}>
      {/* Bottom spacer so the last item can scroll to the top */}
      <div className="order-last min-h-[60vh]" />
      {groups.map((group) => (
        <div key={group.date.toISOString()} data-date={group.date.toISOString().slice(0, 10)}>
          <DateSeparator date={group.date} />

          {/* Items */}
          {group.items.map((item) => (
            <div
              key={item.id}
              className="cursor-pointer"
              onClick={() => onItemClick?.(item.id)}
            >
              {item.content}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
